<template>
    <b-row class="curve-shape">
        <b-col>
            <svg  
            x="0px"
            y="0px" 
            viewBox="0 -14 3841 120"
            style="overflow:scroll;
            enable-background:new 0 -14 3841 120;" 
            xml:space="preserve">
            <slot name="bgcolor"></slot>
        </svg>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: 'CurveShape',
    };
</script>

<style lang="scss" scoped>
    .curve-shape {        
        overflow-x: hidden;
        svg {
            width: 200%;
            position: relative;
            animation: move-left 5s linear infinite;
        } ;
    }
        
    @keyframes move-left {
        0%{
            left: 0%;
        }
        100%{
            left: -100%;
        }     
    }
</style>